export default "__VITE_ASSET__CyEbdg$k__"